import React from 'react';
import { motion } from 'framer-motion';
import SEO from '../components/common/SEO';

const Privacy = () => {
  return (
    <div className="pt-32 pb-20 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto">
      <SEO
        title="Privacy Policy"
        description="Privacy policy and GDPR data protection information for AlienProduction, including newsletter and SendFox processing details."
        canonical="/privacy"
      />

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <h1 className="text-4xl font-extrabold text-zinc-950 uppercase tracking-tight mb-12">
          Privacy Policy
        </h1>

        <div className="prose prose-zinc max-w-none space-y-12 text-zinc-600">
          <section>
            <h2 className="text-xl font-bold text-zinc-950 mb-4 uppercase">
              Who is responsible for data processing?
            </h2>
            <p className="leading-relaxed">
              The responsible party for data processing on this website is:
            </p>
            <p className="mt-4 leading-relaxed whitespace-pre-line font-medium text-zinc-900">
              Mathias Deppe<br />
              Nemesi Valls 42<br />
              08210 Barberà del Vallès<br />
              Barcelona, Spain<br />
              Email:{' '}
              <a
                href="mailto:contact@alienproduction.store"
                className="text-zinc-950 hover:underline"
              >
                contact@alienproduction.store
              </a>
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-zinc-950 mb-4 uppercase">
              What personal data do we collect and why?
            </h2>
            <p className="leading-relaxed">
              We collect and process personal data only when it is necessary to
              provide a functional website, content, and our services. This
              website does not use any cookies or similar tracking technologies.
            </p>
            <p className="mt-4 leading-relaxed">
              If you contact us by email, the data you provide, such as your
              email address, name, and the content of your message, will be
              stored by us in order to process your request and respond to your
              inquiry.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-zinc-950 mb-4 uppercase">
              How does the newsletter use SendFox?
            </h2>
            <p className="leading-relaxed">
              If you would like to receive the newsletter offered on the
              website, we require an email address from you. We use{' '}
              <strong>SendFox</strong>, a service provided by Sumo Group Inc.,
              1305 E 6th St #3, Austin, TX 78702, USA, to send our newsletters.
            </p>
            <p className="mt-4 leading-relaxed">
              When you register for our newsletter, the data you provide, such
              as your email address, is transferred to SendFox and stored on
              their servers in the USA. The legal basis for processing your data
              for the newsletter is your explicit consent (Art. 6 (1) lit. a
              GDPR). You can revoke your consent to the storage of the data,
              the email address, and their use for sending the newsletter at any
              time, for example, via the unsubscribe link in the newsletter.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-zinc-950 mb-4 uppercase">
              What is the legal basis for processing?
            </h2>
            <p className="leading-relaxed">
              The processing of data entered when contacting us is based on your
              consent (Art. 6 (1) lit. a GDPR) or for the performance of a
              contract or pre-contractual measures (Art. 6 (1) lit. b GDPR).
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-zinc-950 mb-4 uppercase">
              How long do we retain personal data?
            </h2>
            <p className="leading-relaxed">
              We retain your personal data only for as long as is necessary for
              the respective purpose or as required by legal retention periods.
              After that, the corresponding data is routinely deleted.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-zinc-950 mb-4 uppercase">
              What are your rights under the GDPR?
            </h2>
            <p className="leading-relaxed">
              Under the GDPR, you have the right to request information about
              your stored personal data at any time. Furthermore, you have the
              right to request the correction, restriction of processing, or
              deletion of this data. You also have the right to data
              portability and the right to lodge a complaint with the competent
              supervisory authority, in Spain: <strong>Agencia Española de
              Protección de Datos - AEPD</strong>.
            </p>
            <p className="mt-6 leading-relaxed">
              To exercise your rights, simply send an email to:{' '}
              <a
                href="mailto:contact@alienproduction.store"
                className="text-zinc-950 font-bold hover:underline"
              >
                contact@alienproduction.store
              </a>
            </p>
          </section>
        </div>
      </motion.div>
    </div>
  );
};

export default Privacy;